import { Select } from 'antd';
import styled from 'styled-components';

import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { Select as SelectV2 } from '@/shared/uikitV2/Select';

export const ItemWrapper = styled.div`
  grid-column: var(--grid-column, auto);

  ${media.mobile} {
    grid-column: auto;
  }

  // input
  .highlight > .default {
    background-color: ${COLORS.systemSun100};
  }

  // select
  .highlight > .select-wrapper > [role='combobox'] {
    background-color: ${COLORS.systemSun100};
  }

  // date picker
  .form-v2-date-picker.highlight {
    background-color: ${COLORS.systemSun100};

    &:hover {
      background-color: ${COLORS.systemSun100};
    }
  }

  // checkbox
  .form-v2-checkbox.highlight .label-text {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: -3px;
      bottom: -3px;
      right: -4px;
      left: -4px;
      background-color: ${COLORS.systemSun100};
      border-radius: 4px;
    }
  }
`;

export const PhoneNumberWrapper = styled.div`
  display: grid;
  column-gap: 4px;
  grid-template-columns: 100px auto;
  width: 100%;
`;

export const DropdownPhoneNumber = styled(Select)`
  display: grid;
  column-gap: 4px;
  grid-template-columns: 100px auto;
  width: 100%;
`;

export const FileUploadingContainer = styled.div`
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledSelectV2 = styled(SelectV2)`
  .option-content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: center;
    gap: 6px;
  }

  // select
  &.highlight > .select-wrapper > [role='combobox'] {
    background-color: ${COLORS.systemSun100};
  }
`;
